import { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { API_FORMAT } from 'constants/dates';

export default class DateField extends Component {
    static propTypes = {
        date: PropTypes.string,
    };

    static defaultProps = {
        format: 'DD MMMM YYYY',
    };

    render() {
        const { date, format } = this.props;

        return moment(date, API_FORMAT).isValid() ? (
            moment(date, API_FORMAT).format(format)
        ) : '';
    }
}



// WEBPACK FOOTER //
// ./src/components/common/fields/Date.js